import React, { useState } from 'react';

export default function AuthForm({ onVerified, onCancel }) {
  const [step, setStep] = useState('email'); // 'email' or 'pin'
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');

  const handleSendPin = async () => {
    try {
      const response = await fetch('/api/createAuthRequest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        alert(`PIN sent to ${email}`);
        setStep('pin');
      } else {
        alert('Error sending PIN');
      }
    } catch (err) {
      console.error(err);
      alert('Failed to send PIN.');
    }
  };

  const handleVerifyPin = async () => {
    try {
      const response = await fetch('/api/verifyAuthRequest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, pin })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        onVerified(data.user.email);
      } else {
        alert('Invalid PIN');
      }
    } catch (err) {
      console.error(err);
      alert('Failed to verify PIN.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 flex flex-col items-center">
      <h1 className="text-2xl font-bold mb-6">Verify Email</h1>

      <div className="bg-white p-6 rounded shadow max-w-md w-full space-y-4">
        {step === 'email' && (
          <>
            <label className="block font-semibold">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
            <button
              onClick={handleSendPin}
              className="w-full py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Send PIN
            </button>
          </>
        )}

        {step === 'pin' && (
          <>
            <label className="block font-semibold">Enter PIN</label>
            <input
              type="text"
              value={pin}
              onChange={e => setPin(e.target.value)}
              className="w-full border p-2 rounded"
              required
            />
            <button
              onClick={handleVerifyPin}
              className="w-full py-3 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Verify PIN
            </button>
          </>
        )}

        <button
          onClick={onCancel}
          className="w-full py-3 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
